/**
 * variants/glow/ViewIcons.jsx
 * View mode SVG glyphs for Homy in "spatial-bento-glow" variant.
 */

import * as React from "react";

function createSvgIcon(name, renderPaths) {
  const Component = React.forwardRef(
    ({ size, width, height, className = "", embedded = false, ...props }, ref) => {
      const dimension = size || width || 24;

      if (embedded) {
        return (
          <g
            ref={ref}
            className={`filter drop-shadow-[0_0_4px_currentColor] ${className}`}
            data-icon={name}
            {...props}
          >
            {renderPaths()}
          </g>
        );
      }

      return (
        <svg
          ref={ref}
          viewBox="0 0 24 24"
          width={dimension}
          height={height || dimension}
          fill="none"
          stroke="currentColor"
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={`filter drop-shadow-[0_0_4px_currentColor] ${className}`}
          data-icon={name}
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          {renderPaths()}
        </svg>
      );
    }
  );
  Component.displayName = name;
  return Component;
}

export const TableViewIcon = createSvgIcon("TableViewIcon", () => (
  <>
    <rect x="3" y="3" width="18" height="18" rx="2" fill="currentColor" fillOpacity="0.25" stroke="none" />
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <path d="M3 9h18M3 15h18M9 9v12M15 9v12" />
  </>
));

export const KanbanViewIcon = createSvgIcon("KanbanViewIcon", () => (
  <>
    <rect x="4" y="4" width="4.5" height="16" rx="1.5" fill="currentColor" fillOpacity="0.25" />
    <rect x="10" y="4" width="4.5" height="11" rx="1.5" fill="currentColor" fillOpacity="0.25" />
    <rect x="16" y="4" width="4.5" height="13" rx="1.5" fill="currentColor" fillOpacity="0.25" />
  </>
));

export const SplitViewIcon = createSvgIcon("SplitViewIcon", () => (
  <>
    <rect x="3" y="3" width="7.5" height="18" rx="1.5" fill="currentColor" fillOpacity="0.25" />
    <rect x="13.5" y="3" width="7.5" height="18" rx="1.5" />
    <path d="M10.5 12h3" />
  </>
));

export const GridViewIcon = createSvgIcon("GridViewIcon", () => (
  <>
    <rect x="3" y="3" width="7.5" height="7.5" rx="1.5" fill="currentColor" fillOpacity="0.25" />
    <rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5" />
    <rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5" />
    <rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5" fill="currentColor" fillOpacity="0.25" />
  </>
));

export const MapViewIcon = createSvgIcon("MapViewIcon", () => (
  <>
    <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" fill="currentColor" fillOpacity="0.25" />
    <path d="M8 2v16M16 6v16" />
  </>
));

export const glowViewGlyphs = {
  table: TableViewIcon,
  kanban: KanbanViewIcon,
  split: SplitViewIcon,
  grid: GridViewIcon,
  map: MapViewIcon,
};
